"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n    justify-content: space-between;\n    background-color: ", ";\n    min-height: 56px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.internalFooter = exports.footer = void 0;

var _stylitas = require("@creditas/stylitas");

var footer = function footer() {
  return (0, _stylitas.css)(_templateObject());
};

exports.footer = footer;

var internalFooter = function internalFooter(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return variant === 'internal' && (0, _stylitas.css)(_templateObject2(), theme.bColorneutral03);
};

exports.internalFooter = internalFooter;